/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as BoardRouteImport } from './routes/board';
import { Route as CallsRouteImport } from './routes/calls';
import { Route as CleanupRouteImport } from './routes/cleanup';
import { Route as OverviewRouteImport } from './routes/overview';
import { Route as SettingsRouteImport } from './routes/settings';
import { Route as AccountsAccountIdRouteImport } from './routes/accounts/$accountId';
import { Route as SettingsIndexRouteImport } from './routes/settings/index';
import { Route as SettingsAiRouteImport } from './routes/settings/ai';
import { Route as SettingsIntegrationsRouteImport } from './routes/settings/integrations';
import { Route as SettingsUsersRouteImport } from './routes/settings/users';
import { Route as SettingsVocabRouteImport } from './routes/settings/vocab';
import { Route as TicketsTicketIdRouteImport } from './routes/tickets/$ticketId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const BoardRoute = BoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => rootRouteImport,
} as any);
const CallsRoute = CallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => rootRouteImport,
} as any);
const CleanupRoute = CleanupRouteImport.update({
  id: '/cleanup',
  path: '/cleanup',
  getParentRoute: () => rootRouteImport,
} as any);
const OverviewRoute = OverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountsAccountIdRoute = AccountsAccountIdRouteImport.update({
  id: '/accounts/$accountId',
  path: '/accounts/$accountId',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsAiRoute = SettingsAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsVocabRoute = SettingsVocabRouteImport.update({
  id: '/vocab',
  path: '/vocab',
  getParentRoute: () => SettingsRoute,
} as any);
const TicketsTicketIdRoute = TicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/board': typeof BoardRoute;
  '/calls': typeof CallsRoute;
  '/cleanup': typeof CleanupRoute;
  '/overview': typeof OverviewRoute;
  '/settings': typeof SettingsRouteWithChildren;
  '/accounts/$accountId': typeof AccountsAccountIdRoute;
  '/settings/ai': typeof SettingsAiRoute;
  '/settings/integrations': typeof SettingsIntegrationsRoute;
  '/settings/users': typeof SettingsUsersRoute;
  '/settings/vocab': typeof SettingsVocabRoute;
  '/tickets/$ticketId': typeof TicketsTicketIdRoute;
  '/settings/': typeof SettingsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/board': typeof BoardRoute;
  '/calls': typeof CallsRoute;
  '/cleanup': typeof CleanupRoute;
  '/overview': typeof OverviewRoute;
  '/accounts/$accountId': typeof AccountsAccountIdRoute;
  '/settings/ai': typeof SettingsAiRoute;
  '/settings/integrations': typeof SettingsIntegrationsRoute;
  '/settings/users': typeof SettingsUsersRoute;
  '/settings/vocab': typeof SettingsVocabRoute;
  '/tickets/$ticketId': typeof TicketsTicketIdRoute;
  '/settings': typeof SettingsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/board': typeof BoardRoute;
  '/calls': typeof CallsRoute;
  '/cleanup': typeof CleanupRoute;
  '/overview': typeof OverviewRoute;
  '/settings': typeof SettingsRouteWithChildren;
  '/accounts/$accountId': typeof AccountsAccountIdRoute;
  '/settings/ai': typeof SettingsAiRoute;
  '/settings/integrations': typeof SettingsIntegrationsRoute;
  '/settings/users': typeof SettingsUsersRoute;
  '/settings/vocab': typeof SettingsVocabRoute;
  '/tickets/$ticketId': typeof TicketsTicketIdRoute;
  '/settings/': typeof SettingsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/board'
    | '/calls'
    | '/cleanup'
    | '/overview'
    | '/settings'
    | '/accounts/$accountId'
    | '/settings/ai'
    | '/settings/integrations'
    | '/settings/users'
    | '/settings/vocab'
    | '/tickets/$ticketId'
    | '/settings/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/board'
    | '/calls'
    | '/cleanup'
    | '/overview'
    | '/accounts/$accountId'
    | '/settings/ai'
    | '/settings/integrations'
    | '/settings/users'
    | '/settings/vocab'
    | '/tickets/$ticketId'
    | '/settings';
  id:
    | '__root__'
    | '/'
    | '/board'
    | '/calls'
    | '/cleanup'
    | '/overview'
    | '/settings'
    | '/accounts/$accountId'
    | '/settings/ai'
    | '/settings/integrations'
    | '/settings/users'
    | '/settings/vocab'
    | '/tickets/$ticketId'
    | '/settings/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  BoardRoute: typeof BoardRoute;
  CallsRoute: typeof CallsRoute;
  CleanupRoute: typeof CleanupRoute;
  OverviewRoute: typeof OverviewRoute;
  SettingsRoute: typeof SettingsRouteWithChildren;
  AccountsAccountIdRoute: typeof AccountsAccountIdRoute;
  TicketsTicketIdRoute: typeof TicketsTicketIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/board': {
      id: '/board';
      path: '/board';
      fullPath: '/board';
      preLoaderRoute: typeof BoardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/calls': {
      id: '/calls';
      path: '/calls';
      fullPath: '/calls';
      preLoaderRoute: typeof CallsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cleanup': {
      id: '/cleanup';
      path: '/cleanup';
      fullPath: '/cleanup';
      preLoaderRoute: typeof CleanupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/overview': {
      id: '/overview';
      path: '/overview';
      fullPath: '/overview';
      preLoaderRoute: typeof OverviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accounts/$accountId': {
      id: '/accounts/$accountId';
      path: '/accounts/$accountId';
      fullPath: '/accounts/$accountId';
      preLoaderRoute: typeof AccountsAccountIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/': {
      id: '/settings/';
      path: '/';
      fullPath: '/settings/';
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/ai': {
      id: '/settings/ai';
      path: '/ai';
      fullPath: '/settings/ai';
      preLoaderRoute: typeof SettingsAiRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/integrations': {
      id: '/settings/integrations';
      path: '/integrations';
      fullPath: '/settings/integrations';
      preLoaderRoute: typeof SettingsIntegrationsRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/users': {
      id: '/settings/users';
      path: '/users';
      fullPath: '/settings/users';
      preLoaderRoute: typeof SettingsUsersRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/vocab': {
      id: '/settings/vocab';
      path: '/vocab';
      fullPath: '/settings/vocab';
      preLoaderRoute: typeof SettingsVocabRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/tickets/$ticketId': {
      id: '/tickets/$ticketId';
      path: '/tickets/$ticketId';
      fullPath: '/tickets/$ticketId';
      preLoaderRoute: typeof TicketsTicketIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

interface SettingsRouteChildren {
  SettingsAiRoute: typeof SettingsAiRoute;
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute;
  SettingsUsersRoute: typeof SettingsUsersRoute;
  SettingsVocabRoute: typeof SettingsVocabRoute;
  SettingsIndexRoute: typeof SettingsIndexRoute;
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAiRoute: SettingsAiRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsVocabRoute: SettingsVocabRoute,
  SettingsIndexRoute: SettingsIndexRoute,
};

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BoardRoute: BoardRoute,
  CallsRoute: CallsRoute,
  CleanupRoute: CleanupRoute,
  OverviewRoute: OverviewRoute,
  SettingsRoute: SettingsRouteWithChildren,
  AccountsAccountIdRoute: AccountsAccountIdRoute,
  TicketsTicketIdRoute: TicketsTicketIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
